import { httpClient } from '@/services/http/httpClient'

type DeleteIdeaWorkflowStepParams = {
  workflowStepId: string
}

export const deleteIdeaWorkflowStep = async ({
  workflowStepId,
}: DeleteIdeaWorkflowStepParams) => {
  await httpClient.delete(`/ideas/funnel/steps/${workflowStepId}`)
}
